export default __webpack_public_path__ + "static/former-avrundet-rektangulaere2-847fe191c6ffef19d8525dc5d7381fe4.png";